import { render, staticRenderFns } from "./StartClaimTable.vue?vue&type=template&id=0a79afca&scoped=true&"
import script from "./StartClaimTable.vue?vue&type=script&lang=js&"
export * from "./StartClaimTable.vue?vue&type=script&lang=js&"
import style0 from "./StartClaimTable.vue?vue&type=style&index=0&id=0a79afca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a79afca",
  null
  
)

export default component.exports